'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        positionBottom: {
            type: Number,
            kComposite: 'position.bottom'
        },
        positionLeft: {
            type: Number,
            kComposite: 'position.left'
        },
        positionPinned: {
            type: Boolean,
            kComposite: 'position.pinned'
        },
        positionRight: {
            type: Number,
            kComposite: 'position.right'
        },
        positionTop: {
            type: Number,
            kComposite: 'position.top'
        }
    }
};